import {Component} from '@angular/core';

@Component({
  selector: 'app-modal-oferta',
  templateUrl: './modal-oferta.component.html',
  styleUrls: ['./modal-oferta.component.scss']
})
export class ModalOfertaComponent {
  public isModalOfertaShow: boolean = false;
  public isDarkBackground: boolean = false;

  openModalOfertaShow() {
    this.isModalOfertaShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isModalOfertaShow = false;
    this.isDarkBackground = false;
  }
}
